<template>    
    <PageFull header="Адм. платежные системы" type="white" :fullwidth="true" :nopadding="true">
        <template v-slot:body>
            <div class="flex flex-column w-full">
                <PaysList />
            </div>
        </template>
    </PageFull>
</template>

<script>
import PaysList from '@/components/admin/PaysList.vue'
import PageFull from '@/components/sides/PageFull.vue'

export default {
    data() {
        return {
            
        }
    },
    components: {
        PaysList,
        PageFull  
    },
}
</script>